<template>
  <div class="jeVerifie">
    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors mb-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>
    <div class="jeVerifiePage">
      <!-- Photo -->
      <div class="row d-flex justify-content-center">
        <img
          class="photo-img mt-5"
          :src="[
            preinscription.data.document.documentPhoto.data != null
              ? 'data:image/gif;base64,' +
                preinscription.data.document.documentPhoto.data
              : require('@/assets/preinscription_photo.png')
          ]"
        />
      </div>
      <p
        class="jeVerifieText d-flex justify-content-center mt-3 pb-3"
        style="font-style:italic; text-decoration: underline; cursor:pointer;"
        @click="retourEtape(3)"
      >
        {{ "preinscription_photo_bouton_modifier" | translate(locale) }}
      </p>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je suis -->
      <div class="jeSuisPart">
        <img class="mt-4 mb-2 ml-1" src="@/assets/user-plus.png" />
        <p class="jeVerifieTitle">JE SUIS</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 75px"></div>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_prenom" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">{{ preinscription.data.prenom }}</p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_nom" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">{{ preinscription.data.nom }}</p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_nom_naissance" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{
              preinscription.data.nomNaissance != null
                ? preinscription.data.nomNaissance
                : ""
            }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_nationalite" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.nationalite.libelle }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_sexe" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{
              preinscription.data.sexe === null
                ? ""
                : preinscription.data.sexe === "F"
                ? "Feminin"
                : preinscription.data.sexe === "M"
                ? "Masculin"
                : ""
            }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_taille" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.informationMedicale.taille }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_date_naissance" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ this.formatDateFrancais(preinscription.data.dateNaissance) }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_ville_naissance" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{
              preinscription.data.generalite.communeNaissance.codePostal !=
                null &&
              preinscription.data.generalite.communeNaissance.libelle != null
                ? preinscription.data.generalite.communeNaissance.codePostal +
                  " - " +
                  preinscription.data.generalite.communeNaissance.libelle
                : ""
            }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_ville_naissance_etranger" | translate(locale) }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.villeEtrangereNaissance }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_pays_naissance_etranger" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.nationaliteNaissance.libelle }}
          </p>
        </div>
        <div
          v-if="
            getAge() >= 18 &&
              preinscription.data.generalite.nationaliteNaissance.code !=
                null &&
              preinscription.data.generalite.nationaliteNaissance.code != 'FRA'
          "
        >
          <div class="row">
            <p class="jeVerifieText">
              {{ "preinscription_prenom_mere" | translate(locale) }}
              :
            </p>
            <p class="jeVerifieTextBold">
              {{ preinscription.data.prenomMere }}
            </p>
          </div>
          <div class="row">
            <p class="jeVerifieText">
              {{ "preinscription_nom_mere" | translate(locale) }}
              :
            </p>
            <p class="jeVerifieTextBold">
              {{ preinscription.data.nomMere }}
            </p>
          </div>
          <div class="row">
            <p class="jeVerifieText">
              {{ "preinscription_prenom_pere" | translate(locale) }}
              :
            </p>
            <p class="jeVerifieTextBold">
              {{ preinscription.data.prenomPere }}
            </p>
          </div>
          <div class="row">
            <p class="jeVerifieText">
              {{ "preinscription_nom_pere" | translate(locale) }}
              :
            </p>
            <p class="jeVerifieTextBold">
              {{ preinscription.data.nomPere }}
            </p>
          </div>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_adresse_rue" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.rue }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_adresse_complement" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.complementRue }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_adresse_pays" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.nationaliteAdresse.libelle }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_adresse_ville" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{
              preinscription.data.generalite.communeVille.codePostal != null &&
              preinscription.data.generalite.communeVille.libelle != null
                ? preinscription.data.generalite.communeVille.codePostal +
                  " - " +
                  preinscription.data.generalite.communeVille.libelle
                : ""
            }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_ville_etranger" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.villeEtrangere }}
          </p>
        </div>

        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_mail" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.mail }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_tel_domicile" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.telephoneDomicile }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "preinscription_tel_portable" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.telephonePortable }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{
              "preinscription_prenom_pere_representant_legal"
                | translate(locale)
            }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.prenomPere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{
              "preinscription_nom_pere_representant_legal" | translate(locale)
            }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.nomPere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{ "preinscription_tel_pere" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.telephoneMineurPere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{ "preinscription_mail_pere" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.mailMineurPere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{
              "preinscription_prenom_mere_representant_legal"
                | translate(locale)
            }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.prenomMere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{
              "preinscription_nom_mere_representant_legal" | translate(locale)
            }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.nomMere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{ "preinscription_tel_mere" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.telephoneMineurMere }}
          </p>
        </div>
        <div v-if="getAge() < 18" class="row">
          <p class="jeVerifieText">
            {{ "preinscription_mail_mere" | translate(locale) }} :
          </p>
          <p class="jeVerifieTextBold">
            {{ preinscription.data.generalite.mailMineurMere }}
          </p>
        </div>

        <div class="row mt-3">
          <img
            src="@/assets/edit-3.png"
            style="cursor: pointer;"
            @click="retourEtape(3)"
          />
          <p
            class="jeVerifieText jeVerifieModifier ml-2"
            @click="retourEtape(3)"
          >
            {{ "je_verifie_modifier_info" | translate(locale) }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je Souhaite -->
      <div class="jeSouhaitePart">
        <img class="mt-4 mb-2 ml-1" src="@/assets/thumbs-up.png" />
        <p class="jeVerifieTitle">JE SOUHAITE</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 125px"></div>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "je_verifie_je_souhaite_pratique_sportive" | translate(locale) }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ pratiqueSportiveLibelle }}
          </p>
        </div>
        <div class="row">
          <p class="jeVerifieText">
            {{ "je_verifie_je_souhaite_types_pratique" | translate(locale) }} :
          </p>
          <p v-if="typesPratiqueLibelle.length === 0" class="jeVerifieTextBold">
            {{
              "je_verifie_je_souhaite_zero_types_pratique" | translate(locale)
            }}
          </p>
          <div v-if="typesPratiqueLibelle.length > 0" style="display: contents">
            <p
              v-for="(type, index) in typesPratiqueLibelle"
              :key="index"
              class="jeVerifieTextBold"
            >
              {{
                index === typesPratiqueLibelle.length - 1 ? type : type + " | "
              }}
            </p>
          </div>
        </div>

        <div class="row mt-3">
          <img
            src="@/assets/edit-3.png"
            style="cursor: pointer;"
            @click="retourEtape(4)"
          />
          <p
            class="jeVerifieText jeVerifieModifier ml-2"
            @click="retourEtape(4)"
          >
            {{ "je_verifie_modifier_info" | translate(locale) }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <div class="mesJustificatifsPart">
        <img class="mt-4 mb-2 ml-1" src="@/assets/file-text.png" />
        <p class="jeVerifieTitle">JE PRODUIS MES JUSTIFICATIFS</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 280px"></div>
        </div>
        <!-- Surclassement -->
        <div
          v-if="
            listeJustificatifs.filter(j => j.type === 'SURCLASSEMENT').length >
              0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{
              "je_verifie_mes_justificatifs_surclassement" | translate(locale)
            }}
            :
          </p>
          <p
            v-if="
              preinscription.data.informationMedicale
                .certificatIdentiqueSurclassement
            "
            class="jeVerifieTextBold"
          >
            {{
              "je_verifie_mes_justificatifs_surclassement_CM_identique"
                | translate(locale)
            }}
          </p>
          <p
            v-if="
              !preinscription.data.informationMedicale
                .certificatIdentiqueSurclassement
            "
            class="jeVerifieTextBold"
            style="cursor: pointer;"
            @click="
              downloadDocument(
                preinscription.data.document.documentSurclassement
              )
            "
          >
            {{ preinscription.data.document.documentSurclassement.nom }}
          </p>
        </div>
        <!-- Piece d'identite recto -->
        <div
          v-if="
            listeJustificatifs.filter(j => j.type === 'CARTE_IDENTITE').length >
              0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "piece_identite_recto" | translate(locale) }}
            :
          </p>
          <p
            class="jeVerifieTextBold"
            style="cursor: pointer;"
            @click="
              downloadDocument(
                preinscription.data.document.documentPieceIdentiteRecto
              )
            "
          >
            {{ preinscription.data.document.documentPieceIdentiteRecto.nom }}
          </p>
        </div>

        <!-- Piece d'identite verso -->
        <div
          v-if="
            listeJustificatifs.filter(j => j.type === 'CARTE_IDENTITE').length >
              0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "piece_identite_verso" | translate(locale) }}
            :
          </p>
          <p
            class="jeVerifieTextBold"
            style="cursor: pointer;"
            @click="
              downloadDocument(
                preinscription.data.document.documentPieceIdentiteVerso
              )
            "
          >
            {{ preinscription.data.document.documentPieceIdentiteVerso.nom }}
          </p>
        </div>

        <!-- Certificat medical -->
        <div
          v-if="
            listeJustificatifs.filter(j => j.type === 'CERTIFICAT_MEDICAL')
              .length > 0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "certificat_medical" | translate(locale) }}
            :
          </p>
          <p
            class="jeVerifieTextBold"
            style="cursor: pointer;"
            @click="
              downloadDocument(
                preinscription.data.document.documentCertificatMedical
              )
            "
          >
            {{ preinscription.data.document.documentCertificatMedical.nom }}
          </p>
          <p
            v-if="
              preinscription.data.informationMedicale.dateCertificatMedical !=
                null
            "
            class="jeVerifieText ml-2"
          >
            {{ "date_certificat_medical" | translate(locale) }}
            :
          </p>
          <p
            v-if="
              preinscription.data.informationMedicale.dateCertificatMedical !=
                null
            "
            class="jeVerifieTextBold"
          >
            {{
              this.formatDateFrancais(
                preinscription.data.informationMedicale.dateCertificatMedical
              )
            }}
          </p>
        </div>

        <!-- Date questionnaire santé -->
        <div
          v-if="
            preinscription.data.informationMedicale.dateQuestionnaireSante !=
              null
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "je_verifie_questionnaire_sante" | translate(locale) }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{
              this.formatDateFrancais(
                preinscription.data.informationMedicale.dateQuestionnaireSante
              )
            }}
          </p>
        </div>

        <!-- Charte d'engagement -->
        <div
          v-if="
            listeJustificatifs.filter(j => j.type === 'CHARTE_ENGAGEMENT')
              .length > 0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "charte_engagement" | translate(locale) }}
            :
          </p>
          <p class="jeVerifieTextBold">
            signée
          </p>
        </div>

        <!-- Aptitudes métier -->
        <div
          v-if="
            preinscription.data.licence.fonctionsNiveaux != null &&
              preinscription.data.licence.fonctionsNiveaux.length != 0
          "
          class="row"
        >
          <p class="jeVerifieText">
            {{ "je_verifie_aptitudes_metier" | translate(locale) }} :
          </p>
          <p
            v-for="(fonctionNiveau, index) in preinscription.data.licence
              .fonctionsNiveaux"
            :key="index"
            class="jeVerifieTextBold"
          >
            {{
              index === preinscription.data.licence.fonctionsNiveaux.length - 1
                ? fonctionNiveau.fonction.libelle +
                  " - " +
                  fonctionNiveau.niveau.libelle
                : fonctionNiveau.fonction.libelle +
                  " - " +
                  fonctionNiveau.niveau.libelle +
                  " | "
            }}
          </p>
        </div>

        <div class="row mt-3">
          <img
            src="@/assets/edit-3.png"
            style="cursor: pointer;"
            @click="retourEtape(5)"
          />
          <p
            class="jeVerifieText jeVerifieModifier ml-2"
            @click="retourEtape(5)"
          >
            {{ "je_verifie_modifier_info" | translate(locale) }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je m'assure -->
      <div class="jeMassurePart">
        <img class="mt-4 mb-2 ml-1" src="@/assets/book.png" />
        <p class="jeVerifieTitle">JE M'ASSURE</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 120px"></div>
        </div>

        <p class="jeVerifieText mb-3">
          {{ "je_verifie_je_massure_text" | translate(locale) }}
        </p>

        <div class="row">
          <p class="jeVerifieText">
            {{ "je_verifie_assurance_text_1" | translate(locale) }}
            {{ preinscription.data.saison.libelle.toLowerCase() }}
            {{ "je_verifie_assurance_text_2" | translate(locale) }}
            :
          </p>
          <p class="jeVerifieTextBold">
            {{ assuranceLibelle }}
          </p>
        </div>

        <div class="row mt-3">
          <img
            src="@/assets/edit-3.png"
            style="cursor: pointer;"
            @click="retourEtape(6)"
          />
          <p
            class="jeVerifieText jeVerifieModifier ml-2"
            @click="retourEtape(6)"
          >
            {{ "je_verifie_modifier_info" | translate(locale) }}
          </p>
        </div>
      </div>

      <div
        class="row mt-4 mb-3 w-100"
        style="border: 0.5px solid #d8d8d8; opacity: 0.24;"
      />

      <!-- Je cotise -->
      <div class="jeCotisePart">
        <img class="mt-4 mb-2 ml-1" src="@/assets/cotisation.png" />
        <p class="jeVerifieTitle">JE COTISE</p>
        <div class="row d-flex justify-content-left mb-4">
          <div class="title_line" style="width: 95px"></div>
        </div>

        <div
          class="pb-4"
          v-if="
            tableauPrixLicencie &&
              tableauPrixLicencie !== 'undefined' &&
              tableauPrixLicencie.length > 0
          "
        >
          <p class="jeVerifieText">
            {{ "je_verifie_montant_text_1" | translate(locale) }}
            {{ preinscription.data.saison.libelle.toLowerCase() }} :
          </p>
          <div
            v-for="(prixLicencie, index) in this.tableauPrixLicencie"
            :key="index"
            class="row jeVerifieText listePrixLicencie"
            style="display: table;"
          >
            <div class="p-0">{{ prixLicencie.value1 }} :</div>
            <div
              class="jeVerifieTextBold p-0"
              style="margin-left: 0; text-align: right; display: table-cell;"
            >
              {{ prixLicencie.value2 }}
            </div>
          </div>
        </div>
        <div
          class="row pb-4"
          v-if="
            tableauPrixLicencie &&
              tableauPrixLicencie !== 'undefined' &&
              tableauPrixLicencie.length === 0
          "
        >
          <p class="jeVerifieText">
            {{ "je_verifie_montant_text_2" | translate(locale) }}
            {{ preinscription.data.saison.libelle.toLowerCase() }}
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="erreurGlobale != null"
      class="alert alert-danger text-left global-errors mt-5"
    >
      <p>
        {{ erreurGlobale }}
      </p>
    </div>
  </div>
</template>

<script>
import translations from "@/Translations.js";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import _ from "lodash";

export default {
  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      pratiqueSportiveLibelle: "",
      assuranceLibelle: "",
      typesPratiqueLibelle: [],
      listeJustificatifs: [],
      tableauPrixLicencie: undefined,
      token_out: undefined
    };
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    canContinue() {
      this.$emit("can-continue", {
        value: true,
        preinscription: this.preinscription
      });
    },
    getAge() {
      if (!this.preinscription.data) {
        return 0;
      }
      var dateNaissance = this.preinscription.data.dateNaissance;
      var dateFinSaison = this.preinscription.data.saison.fin;
      return preinscriptionAppelsServeur.getAgeLicencie(
        dateNaissance,
        dateFinSaison
      );
    },
    getPratiqueSportiveLibelle(isReconnected) {
      var that = this;
      let code = this.preinscription.data.pratiqueSportive;
      if (code != null) {
        preinscriptionAppelsServeur
          .getByName(this.token_out, "TypePratiqueSportive")
          .then(result => {
            let pratiqueSportive = _.filter(result.data, ["code", code]);
            if (pratiqueSportive[0]) {
              that.pratiqueSportiveLibelle = pratiqueSportive[0].libelle;
            }
          })
          .catch(error => {
            // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
            var argsArray = [];
            preinscriptionAppelsServeur.traitementErreursServeur(
              error,
              isReconnected,
              that,
              that.getPratiqueSportiveLibelle,
              argsArray
            );
          });
      } else if (this.preinscription.data.typesPratique.includes("VS")) {
        that.pratiqueSportiveLibelle = "VxE - Basket Santé";
      } else if (this.preinscription.data.typesPratique.includes("VT")) {
        that.pratiqueSportiveLibelle = "VxE - BaskeTonik";
      } else if (this.preinscription.data.typesPratique.includes("VI")) {
        that.pratiqueSportiveLibelle = "VxE - Basket Inclusif";
      } else if (this.preinscription.data.typesPratique.includes("M")) {
        that.pratiqueSportiveLibelle = "Micro Basket";
      } else {
        that.pratiqueSportiveLibelle =
          "Je ne souhaite pas pratiquer le basket avec ma licence";
      }
    },
    getTypesPratiqueLibelle(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getByName(this.token_out, "TypePratique")
        .then(result => {
          that.preinscription.data.typesPratique.forEach(type => {
            if (
              type != "J" &&
              type != "VS" &&
              type != "VT" &&
              type != "VI" &&
              type != "M"
            ) {
              let typePratique = _.filter(result.data, ["code", type]);
              if (typePratique[0]) {
                that.typesPratiqueLibelle.push(typePratique[0].libelle);
              }
            }
          });
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getTypesPratiqueLibelle,
            argsArray
          );
        });
    },
    getAssuranceLibelle(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getByName(this.token_out, "TypeAssurance")
        .then(result => {
          let assurancesFiltreesParSaison = _.filter(result.data, function(a) {
            return (
              a.saisonDebut != null &&
              a.saisonDebut.id <= that.preinscription.data.saison.id &&
              (a.saisonFin == null ||
                a.saisonFin.id >= that.preinscription.data.saison.id)
            );
          });

          let assurance = _.filter(assurancesFiltreesParSaison, [
            "code",
            this.preinscription.data.generalite.assurance.code
          ]);
          if (assurance[0]) {
            if (!_.isEmpty(this.preinscription.data.assuranceOrganisme)) {
              let assuranceOrganisme = _.find(
                this.preinscription.data.assuranceOrganisme,
                function(e) {
                  return e.code === assurance[0].code;
                }
              );

              that.assuranceLibelle = assurance[0].libellePreinscription;
              if (assuranceOrganisme) {
                that.assuranceLibelle += " (prise en charge par le club)";
              }
            } else {
              that.assuranceLibelle = assurance[0].libellePreinscription;
            }
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getAssuranceLibelle,
            argsArray
          );
        });
    },
    getJustificatifs(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getJustificatifs(this.token_out, false /*mutation*/)
        .then(result => {
          that.listeJustificatifs = result.data;
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getJustificatifs,
            argsArray
          );
        });
    },
    getTableauPrixLicencie(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getTableauPrixLicencie(this.token_out)
        .then(result => {
          that.tableauPrixLicencie = result.data;
          if (that.tableauPrixLicencie.length > 0) {
            var index;
            for (index = 0; index < that.tableauPrixLicencie.length; index++) {
              that.tableauPrixLicencie[index].value2 = that.formatMontant(
                that.tableauPrixLicencie[index].value2
              );
              if (that.tableauPrixLicencie[index].value1 === "Remise %") {
                that.tableauPrixLicencie[index].value2 =
                  that.tableauPrixLicencie[index].value2 + " %";
              } else {
                that.tableauPrixLicencie[index].value2 =
                  that.tableauPrixLicencie[index].value2 + " €";
              }
            }
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getTableauPrixLicencie,
            argsArray
          );
        });
    },
    retourEtape(numeroEtape) {
      this.$emit("go-back", { numeroEtape: numeroEtape });
    },
    downloadDocument(documentObj) {
      try {
        var fileURL = "data:application/pdf;base64," + documentObj.data;
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", documentObj.nom);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.erreurGlobale =
          "Une erreur est survenue lors du téléchargement du document";
      }
    },
    formatDateFrancais(date) {
      // format date au format français dd/MM/yyyy (la date d'entrée est au format yyyy-MM-dd)
      return preinscriptionAppelsServeur.formatDateFrancais(date);
    },
    formatMontant(montant) {
      // format montant au format français ###,##
      return preinscriptionAppelsServeur.formatMontant(montant);
    }
  },
  created() {
    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getPratiqueSportiveLibelle(false /*isReconnected*/);
    this.getTypesPratiqueLibelle(false /*isReconnected*/);
    this.getAssuranceLibelle(false /*isReconnected*/);
    this.getJustificatifs(false /*isReconnected*/);
    if (
      this.preinscription.data.paiement != null &&
      this.preinscription.data.paiement.validation === true
    ) {
      this.getTableauPrixLicencie(false /*isReconnected*/);
    } else {
      this.tableauPrixLicencie = [];
    }
  }
};
</script>

<style scoped>
.jeVerifiePage {
  background-color: #f0f0f1;
}

.jeVerifiePage .row {
  margin-left: 0;
  margin-right: 0;
  /* width: 50%; */
}

.jeSuisPart,
.jeSouhaitePart,
.mesJustificatifsPart,
.jeMassurePart,
.jeCotisePart {
  text-align: left;
  /* padding-left: 100px;
  position: relative;
  left: 50%; */
  padding-left: 20%;
  padding-right: 20%;
}

.jeVerifieTitle {
  margin-bottom: 10px;
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

.jeVerifieText {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
}

.jeVerifieTextBold {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-left: 10px;
}

.jeVerifieModifier {
  font-size: 14px;
  color: #dc3545;
  cursor: pointer;
}

p {
  margin-bottom: 5px;
}

.title_line {
  border-bottom: 8px solid #00abe7;
  margin-left: -5px;
  width: 100%;
  opacity: 0.5;
  bottom: 0px;
}

.jeVerifie {
  margin: 3rem 8rem;
}

.listePrixLicencie {
  width: 50%;
}

@media (max-width: 768px) {
  .jeSuisPart,
  .jeSouhaitePart,
  .mesJustificatifsPart,
  .jeMassurePart,
  .jeCotisePart {
    text-align: left;
    padding-left: 10%;
    padding-right: 10%;
  }

  .listePrixLicencie {
    width: 100%;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .jeVerifieText,
  .jeVerifieTextBold {
    font-size: 13px;
  }

  .jeVerifieTitle {
    font-size: 16px;
  }

  .jeVerifie {
    margin: 10px 15px;
  }

  .listePrixLicencie {
    width: 100%;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .jeVerifie {
    margin: 3rem 3rem;
  }

  .listePrixLicencie {
    width: 70%;
  }
}
</style>
